var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"Attachmentdetail",attrs:{"id":"Attachmentdetail","hide-footer":"","hide-header":"","size":"xl"}},[_c('img',{attrs:{"src":_vm.imgurl}})])}
var staticRenderFns = []

export { render, staticRenderFns }